{
  "version": 1,
  "asset_id": "b452406b-faf4-4c83-9912-54c58ee326f5",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/b452406b-faf4-4c83-9912-54c58ee326f5/beverly-hills-shingle-roof-tear-off-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/b452406b-faf4-4c83-9912-54c58ee326f5/beverly-hills-shingle-roof-tear-off-768w.avif",
  "original_filename": "beverly-hills-shingle-roof-tear-off-768w.avif",
  "size": 43075,
  "content_type": "image/avif",
  "created_at": "2026-07-29T14:06:48Z"
}
